export default __webpack_public_path__ + "static/tf-typosymbol-1f954d6e90ceb5bdbef175b80c2bc628.jpg";